declare const WorkerGlobalScope: Record<string, any>;

export const isWorker = typeof WorkerGlobalScope !== 'undefined';

export const isServer = !isWorker && typeof window === 'undefined';

export const isBrowser =
  typeof window !== 'undefined' && typeof window.document !== 'undefined';

export const isBrowserMainThread = isBrowser && !isWorker;
